<template>
  <div>
    <v-card
      :outlined="$vuetify.breakpoint.lgAndUp"
      :flat="$vuetify.breakpoint.mdAndDown"
      class="results-options-card"
    >
      <!-- SMALL DEVICES CLOSE -->
      <v-btn
        v-if="$vuetify.breakpoint.mdAndDown"
        rounded
        depressed
        outlined
        color="white"
        small
        class="mt-3"
        @click="handleClickClose"
      >
        <v-icon
          color="primary"
          class="mr-1"
        >
          mdi-close-circle
        </v-icon>
        <span class="primary--text text-decoration-underline">Close</span>
      </v-btn>

      <!-- TITLE -->
      <v-card-title
        class="py-3"
      >
        Adjust Cover Options
      </v-card-title>

      <v-card-text>
        <!-- EDIT/SUMMARY BTNS -->
        <v-row dense>
          <v-col>
            <v-btn
              block
              outlined
              rounded
              color="primary"
              @click.prevent="onClickEditQuote"
            >
              <v-icon
                small
                class="mr-1"
              >
                mdi-pencil
              </v-icon>
              <span class="caption font-weight-medium">Edit Quote</span>
            </v-btn>
          </v-col>
          <v-col>
            <v-btn
              block
              outlined
              rounded
              color="primary"
              @click="showQuoteDetails"
            >
              <span class="caption font-weight-medium">Quote Summary</span>
            </v-btn>
          </v-col>
        </v-row>

        <v-divider class="mt-3" />

        <slot name="filters" />
      </v-card-text>
    </v-card>

    <!-- UPDATE QUOTE MODAL -->
    <v-card
      v-if="isUpdateQuoteShow"
      class="requote-message"
      elevation="2"
      light
    >
      <v-container
        fluid
        class="text-center d-flex flex-column justify-center align-center  pt-4"
      >
        <p
          class="mb-2 primary--text font-weight-medium"
        >
          Finished tailoring your policy?
        </p>
        <p
          class="body-2 mb-0 font-weight-medium"
        >
          When you’re done just click ‘Update Quotes’ to see your updated prices
        </p>
        <v-card-actions
          class="mt-6 card-actions"
        >
          <v-btn
            x-large
            color="primary"
            rounded
            class="pl-4 pr-4"
            data-test="update_results_btn"
            @click="$emit('re-quote')"
          >
            <span>Update Quotes</span>
          </v-btn>
          <v-spacer />
          <v-btn
            x-large
            text
            rounded
            color="primary"
            data-test="cancel_btn"
            @click="$emit('cancel-re-quote')"
          >
            <v-icon class="mr-1">
              $qz-close
            </v-icon>
            <span>Cancel</span>
          </v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import { inject } from '@vue/composition-api';

export default {
  name: 'result-options-wrapper',
  props: {
    isUpdateQuoteShow: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    showQuoteDetails () {
      this.internalTrackerResultsPage('quoteSummary', true);
      this.$emit('click-details', ['details-quote-summary']);
    },
    onClickEditQuote () {
      this.internalTrackerResultsPage('editQuote', true);
      return this.$emit('click-edit-quote');
    },
    handleClickClose () {
      return this.$emit('click-close');
    },
  },
  setup () {
    const internalTrackers = inject('internalTrackers');

    return { ...internalTrackers };
  },
};
</script>

<style scoped lang="scss" src='@/assets/scss/results/results-options.scss'></style>
